var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "contacts"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_314_12558",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_314_12558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "contacts_2",
    d: "M4.5 21.3845V20.3845H19.5V21.3845H4.5ZM4.5 3.61523V2.61523H19.5V3.61523H4.5ZM12 13.9999C12.6923 13.9999 13.2821 13.7563 13.7692 13.2691C14.2564 12.7819 14.5 12.1922 14.5 11.4999C14.5 10.8075 14.2564 10.2178 13.7692 9.73061C13.2821 9.24344 12.6923 8.99986 12 8.99986C11.3077 8.99986 10.7179 9.24344 10.2308 9.73061C9.74359 10.2178 9.5 10.8075 9.5 11.4999C9.5 12.1922 9.74359 12.7819 10.2308 13.2691C10.7179 13.7563 11.3077 13.9999 12 13.9999ZM4.61538 18.9999C4.15513 18.9999 3.77083 18.8457 3.4625 18.5374C3.15417 18.229 3 17.8447 3 17.3845V6.61523C3 6.15498 3.15417 5.77069 3.4625 5.46236C3.77083 5.15403 4.15513 4.99986 4.61538 4.99986H19.3846C19.8449 4.99986 20.2292 5.15403 20.5375 5.46236C20.8458 5.77069 21 6.15498 21 6.61523V17.3845C21 17.8447 20.8458 18.229 20.5375 18.5374C20.2292 18.8457 19.8449 18.9999 19.3846 18.9999H4.61538ZM7.05768 17.9999C7.80768 17.3229 8.59422 16.8204 9.4173 16.4922C10.2404 16.164 11.1013 15.9999 12 15.9999C12.8987 15.9999 13.7596 16.164 14.5827 16.4922C15.4058 16.8204 16.1923 17.3229 16.9423 17.9999H19.3846C19.5385 17.9999 19.6795 17.9358 19.8077 17.8076C19.9359 17.6793 20 17.5383 20 17.3845V6.61523C20 6.4614 19.9359 6.32038 19.8077 6.19216C19.6795 6.06396 19.5385 5.99986 19.3846 5.99986H4.61538C4.46154 5.99986 4.32052 6.06396 4.1923 6.19216C4.0641 6.32038 4 6.4614 4 6.61523V17.3845C4 17.5383 4.0641 17.6793 4.1923 17.8076C4.32052 17.9358 4.46154 17.9999 4.61538 17.9999H7.05768ZM8.7 17.9999H15.3C14.8167 17.6665 14.2958 17.4165 13.7375 17.2499C13.1792 17.0832 12.6 16.9999 12 16.9999C11.4 16.9999 10.8208 17.0832 10.2625 17.2499C9.70417 17.4165 9.18333 17.6665 8.7 17.9999ZM12 12.9999C11.5885 12.9999 11.2356 12.8527 10.9413 12.5585C10.6471 12.2643 10.5 11.9114 10.5 11.4999C10.5 11.0883 10.6471 10.7354 10.9413 10.4412C11.2356 10.147 11.5885 9.99986 12 9.99986C12.4115 9.99986 12.7644 10.147 13.0587 10.4412C13.3529 10.7354 13.5 11.0883 13.5 11.4999C13.5 11.9114 13.3529 12.2643 13.0587 12.5585C12.7644 12.8527 12.4115 12.9999 12 12.9999Z",
    fill: "#15B79E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleIcon);
export default __webpack_public_path__ + "static/media/role-icon.a9e897f15b908a4234c4dcdad7ca688a.svg";
export { ForwardRef as ReactComponent };